<template>
<div class='list_wrapper'>
  <div class='buy_list' v-for="item in buyList" :key="item.scoreMallGoodBuyRecordID">
    <div class='circle circle1'></div>
    <div class='circle circle2'></div>
    <div class='circle circle3'></div>
    <div class='circle circle4'></div>
    <div class='buy_list_wrapper'>
      <div class='buy_list_pic_wrapper'>
        <img :src='item.pic' class='buy_list_pic' />
      </div>
      <div class='buy_list_content_wrapper'>
        <div class='buy_list_title'>{{item.goodName}}<text class='buy_num'>（{{item.amount}}份）</text></div>
        <div class='buy_list_user_name'><span :class="item.status=='待发货'?'red':'green'">{{item.status}}</span></div>
      </div>
      <div class='buy_list_time_wrapper'>
        <div class='buy_list_time'>{{item.time}}</div>
        <img src='../../images/dhcg.jpg' class='dhcg' v-if="item.status=='待发货'" />
      </div>
    </div>
  </div>

</div>
</template>
<script type = "text/ecamscript-6">
import {
  getDateDiff
} from "../../common/js/common.js"
import {
  Indicator
} from 'mint-ui'
export default {
  name: "buyScoreMallGoodRecord",
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo),
      page: 1,
      pageSize: 10,
      buyList: []
    }
  },
  created() {
    this.login()
  },
  methods: {
    login() {
      this.$ajax.autoService.
      login("api/getbuyList.php?openID=" + this.userInfo.openId + "&page=" + this.page + "&pageSize=" + this.pageSize).then((res) => {
        this.buyList = this.buyList.concat(res.data.map(function(item) {
          item.time = getDateDiff(new Date(item.time.replace(/-/g, '/')))
          return item
        }))
        //console.log(this.buyList)
      })

      this.$nextTick(() => {
        this.REQUIRE = true;
        this.loading = false;
        Indicator.close()
      });
    },
    scrollBottom() {
      // 滚动到页面底部时，请求前一天的文章内容

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop


      if (((window.screen.height + scrollTop) > (document.body.clientHeight) - 10) && this.REQUIRE) {
        Indicator.open('正在加载更多');
        // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
        this.REQUIRE = false;
        this.loading = true;
        this.page += 1
        this.login()

      }
    }
  },
  mounted() {
    window.onscroll = this.scrollBottom
  },
  beforeDestroy() {
    Indicator.close()
    window.onscroll = ""
  }

}
</script>
<style lang="stylus">
  .list_wrapper
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px
    .buy_list
      width: 100%
      background: #fff
      padding: 18px 20px
      background: #fff
      position: relative
      box-sizing: border-box
      border-bottom: 1px dashed #d5d5d5
      /*px*/
      .circle
        width: 32px
        height: 32px
        background: #f2f2f2
        position: absolute
        border-radius: 16px
      .circle1
        left: -16px
        top: -16px
      .circle2
        right: -16px
        top: -16px
      .circle3
        left: -16px
        bottom: -16px
      .circle4
        right: -16px
        bottom: -16px
      .buy_list_wrapper
        display: flex
        .buy_list_pic_wrapper
           flex: 0 0 160px
           .buy_list_pic
             width: 160px
             height: 160px
        .buy_list_content_wrapper
          flex: 1
          padding-left: 20px
          .buy_list_title
            font-size: 28px
            color: #333
            line-height: 32px
            margin-top: 20px
          .buy_list_user_name
            line-height: 50px
            font-size: 28px
            color: #696969
            margin-top: 30px
            .red
              color:red
            .green
              color:green
            .buy_list_avater
              width: 50px
              height: 50px
              border-radius: 25px
              vertical-align: middle
              margin-right: 20px
        .buy_list_time_wrapper
          flex: 0 0 160px
          text-align: right
          position: relative
          .buy_list_time
            font-size: 22px
            color: #999
          .dhcg
            position: absolute
            right: -18px
            top: 60%
            width: 118px
            height: 101px
            transform:translateY(-50%)
</style>



// WEBPACK FOOTER //
// src/components/userCenter/buyScoreMallGoodRecord.vue